"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAccount = exports.AccountProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useOrders = require("./useOrders");
var _useMachines = require("./useMachines");
var _useCustomer = require("../commerce-api/custom/hooks/useCustomer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-ignore
const AccountContext = /*#__PURE__*/(0, _react.createContext)();
const AccountProvider = ({
  children
}) => {
  const mounted = (0, _react.useRef)();
  const orders = (0, _useOrders.useOrders)();
  const customer = (0, _useCustomer.useCustomer)();
  const machines = (0, _useMachines.useMachines)();
  const [state, setState] = (0, _react.useState)({
    isLoading: true
  });

  // @ts-ignore
  const mergeState = (0, _react.useCallback)(data => {
    // If we become unmounted during an async call that results in updating state, we
    // skip the update to avoid React errors about setting state in unmounted components.
    if (!mounted.current) {
      return;
    }
    setState(_state => _objectSpread(_objectSpread({}, _state), data));
  });

  // We use this to track mounted state.
  (0, _react.useEffect)(() => {
    // @ts-ignore
    mounted.current = true;
    return () => {
      // @ts-ignore
      mounted.current = false;
    };
  }, []);
  const ctx = (0, _react.useMemo)(() => {
    return _objectSpread(_objectSpread({}, state), {}, {
      // Getter functions
      // Provides convenient access to various data points and derivations.
      // ----------------

      get machines() {
        return machines;
      },
      get customer() {
        return customer;
      },
      get orders() {
        return orders;
      }
    });
  }, [state, mergeState, customer]);
  return /*#__PURE__*/_react.default.createElement(AccountContext.Provider, {
    value: ctx
  }, children);
};
exports.AccountProvider = AccountProvider;
AccountProvider.propTypes = {
  children: _propTypes.default.any
};

/**
 * A hook for managing machines state and actions
 * @returns {Object} Machines data and actions
 */
const useAccount = () => {
  return (0, _react.useContext)(AccountContext);
};
exports.useAccount = useAccount;